import { Link } from "react-router-dom";
import { ArrowUpRight, Anchor, CarFront, Home, Sparkles, HardHat } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { serviceCategories, serviceImages } from "@/data/serviceCatalog";
import { Reveal } from "@/components/portfolio/Reveal";

const icons = { yachts: Anchor, automotive: CarFront, residential: Home, marble: Sparkles, construction: HardHat };
const categoryPhotos = { yachts: serviceImages.exterior, automotive: serviceImages.detailing, residential: "/images/work/apartment-12-960.webp", marble: serviceImages.marble, construction: serviceImages.postconstruction };

export default function ServicesPreview() {
  const { t } = useLanguage();
  return <section data-testid="services-section" className="studio-section bg-[#f5f7f8] border-y border-slate-200/70">
    <div className="studio-container">
      <Reveal className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-6 mb-10">
        <div><p className="studio-eyebrow">{t("services.subtitle")}</p><h2 className="studio-heading">{t("services.title")}</h2></div>
        <Link to="/services" data-testid="view-all-services-btn" className="studio-text-link">{t("services.viewAll")}<ArrowUpRight size={18} /></Link>
      </Reveal>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-7 gap-y-10">
        {serviceCategories.map((category, index) => {
          const Icon = icons[category.id];
          return <Reveal key={category.id} delay={(index % 3) * 0.06} data-testid={`service-card-${category.id}`}>
            <Link to={`/services?category=${category.id}`} data-testid={`explore-${category.id}`} className="service-editorial-link group">
              <div className="aspect-[4/3] overflow-hidden bg-slate-200 mb-5">
                <img src={categoryPhotos[category.id]} alt={t(`services.categories.${category.id}`)} width="960" height="720" loading="lazy" decoding="async"
                  data-testid={`preview-service-image-${category.id}`} className="w-full h-full object-contain group-hover:scale-[1.025] transition-transform duration-500 motion-reduce:transform-none" />
              </div>
              <div className="flex gap-3 items-start"><Icon className="h-5 w-5 text-marine-600 shrink-0 mt-1" aria-hidden="true" />
                <h3 className="font-heading font-semibold text-base text-navy-900 flex-1 min-w-0">{t(`services.categories.${category.id}`)}</h3>
                <ArrowUpRight size={20} className="shrink-0 text-slate-500 group-hover:text-marine-600 transition-colors" />
              </div>
              <p className="text-sm leading-relaxed text-slate-500 mt-3">{t(`services.descriptions.${category.id}`)}</p>
            </Link>
          </Reveal>;
        })}
      </div>
    </div>
  </section>;
}